import React, { useContext } from 'react';
import PaymentMethodItem from 'components/payment/PaymentMethodItem';
import { useAppDispatch, useAppSelector } from 'lib/hooks/redux';
import { setPaymentMethod as setWebpayDebito } from 'store/paymentMethod/webpayDebito.slice';
import { ErrorContext } from 'containers/aio/PaymentMethodsContainer/context';
import { useTranslation } from 'react-i18next';
import { useDeliveryMethod } from 'lib/hooks/deliveryMethod';
import { RootState } from 'types/store';
import { useRules } from 'lib/hooks/rules';
import { useDisabledMessage } from 'lib/hooks/disabledMessage';

/**
 * WebpayDebitSelector shows the option to select WebpayDebito as payment method
 * @returns JSX.Element
 */
export function WebpayDebitSelector(): JSX.Element {
    const { t } = useTranslation('error');
    const dispatch = useAppDispatch();
    const dm = useDeliveryMethod();
    const pm = useAppSelector((state) => state.paymentMethod);
    const rules = useRules();

    const disabledMessage = useDisabledMessage().find((dm) => dm.paymentMethod === 'WebpayDebito')
        ?.disabledMessage;

    const couponLoading = useAppSelector(
        (state: RootState) => state.coupon.status === 'pending' || state.cart.status !== 'ok',
    );

    const isSelected = pm.data.selected.includes('WebpayDebito');
    const isLoading = pm.data.loading.includes('WebpayDebito');
    const isBlocked =
        (pm.data.status === 'pending' && !isLoading) ||
        couponLoading ||
        !dm.hasSchedules() ||
        pm.data.loadingPreferred;
    const ctx = useContext(ErrorContext);

    async function setWebpayDebitoPayment() {
        try {
            await dispatch(setWebpayDebito()).unwrap();
        } catch (e) {
            ctx.setError(t('defaultPaymentError.message'));
        }
    }

    return (
        <PaymentMethodItem
            paymentMethodName="Webpay Débito"
            type="webpaydebito"
            widthIcon="60px"
            onClick={setWebpayDebitoPayment}
            selected={isSelected}
            blocked={isBlocked}
            isLoading={isLoading}
            disabled={disabledMessage || !rules.feature('WebpayDebito')}
        />
    );
}
